<mat-toolbar class="navbar">
 @if (isSmallScreen) {
 <button
  (click)="toggleDrawer.emit()"
  class="menu-button mr-4 mt-0"
>
  <div class="bg-[#434144] rounded-md w-10 h-10 flex items-center justify-center">
    <mat-icon class="icon">menu</mat-icon>
  </div>
</button>
  <span class="text-white text-xl font-medium Avenir Next LT Pro Demi italic justify-center">
    {{ currentTitle }}
  </span>
 }
  <span class="spacer"></span>
  @if (appSelectorService.selectedApp(); as app) {
    <button
      (click)="goToSelectApp()"
      class="flex items-center gap-2 px-3 py-1.5 rounded-md bg-[#434144] hover:bg-[#555355] transition-colors text-white text-sm mr-3"
      title="Cambiar aplicación"
    >
      <mat-icon class="text-base leading-none" style="font-size:16px;width:16px;height:16px;">apps</mat-icon>
      <span class="max-w-[160px] truncate">{{ app.appName }}</span>
      <mat-icon class="text-base leading-none opacity-60" style="font-size:14px;width:14px;height:14px;">swap_horiz</mat-icon>
    </button>
  }
  <div class="hidden md:flex border border-gray-600 bg-[#6D6C6D] rounded-md w-10 h-10 items-center justify-center">
    <button mat-icon-button disableRipple>
  <mat-icon>sunny</mat-icon>
</button>
  </div>
</mat-toolbar>